import jwtService from 'app/services/jwtService';
import axios from 'api';
import * as UserActions from './user.actions';

export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_LOADING = 'LOGIN_LOADING';

export function submitLogin({ email, password, recaptcha, navigate }) {
  return async dispatch => {
    dispatch({ type: LOGIN_LOADING });

    try {
      await jwtService.signInWithEmailAndPassword(email, password, recaptcha);
      const user = await jwtService.signInWithToken(navigate);

      const hairdressersMe = await axios.get('hairdressers');

      dispatch(
        UserActions.setUserData({
          ...user,
          hairdresserSelected:
            hairdressersMe?.data?.length === 1
              ? hairdressersMe.data[0]
              : user.hairdresserSelected
        })
      );

      dispatch({
        type: LOGIN_SUCCESS,
        payload: user,
      });
    } catch (error) {
      dispatch({
        type: LOGIN_ERROR,
        payload: error,
      });
    }
  }
}